import React from 'react';
export const HeroIcon = () => {
  return <img alt="hero" src={require('./hero.png')} height={24} width={24} />;
};
